import React from 'react';
import { useTranslation } from 'react-i18next';
import "./style/error_ui.scss";

const ErrorUI = () => {
    const { t } = useTranslation();
    return (
        <section className="error_page">
            <h2>{t("OOP'S something went wrong")}</h2>
        </section>
    )
}

export default React.memo(ErrorUI);